import { put, call, select, takeLatest } from "redux-saga/effects";
import { format } from "date-fns";
import axios from 'axios';

import API_ENDPOINTS from "@services/apiConfig";
import { nodes } from "@constants/filters";
import { filterActionTypes, filterSelectors } from "@store/ducks";

/********** ACTION_TYPES **********/
export const actionTypes = {
  fetchData: "merchantIncentives/INITIATE_FETCH_DATA",
  fetchDataFailed: "merchantIncentives/FETCH_DATA_FAILED",
  fetchDataFulfilled: "merchantIncentives/FETCH_DATA_FULFILLED",
};

/********** REDUCER **********/
const initialState = {
  fetching: false,
  fetched: false,
  data: {},
  errMsg: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetchData: {
      return { ...state, fetching: true };
    }
    case actionTypes.fetchDataFailed: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errMsg: action.payload,
      };
    }
    case actionTypes.fetchDataFulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload,
        errMsg: null,
      };
    }
    default: {
      return state;
    }
  }
};

/********** SELECTORS **********/
export const selectors = {
  getRows: (state) =>
    (state.partnerApp.merchantIncentives.data && state.partnerApp.merchantIncentives.data.incentives) || [],
  getTotalRows: (state) => state.partnerApp.merchantIncentives.data && state.partnerApp.merchantIncentives.data.total_count,
  isFetched: state => state.partnerApp.merchantIncentives.fetched,
};

/********** ACTION_CREATORS **********/
export const actions = {
  fetchData: (data) => ({
    type: actionTypes.fetchData,
    payload: data,
  }),
  fetchDataFailed: (data) => ({
    type: actionTypes.fetchDataFailed,
    payload: data,
  }),
  fetchDataFulfilled: (data) => ({
    type: actionTypes.fetchDataFulfilled,
    payload: data,
  }),
};

/********** WORKERS **********/
function* fetchDataWorker() {
  const state = yield select();
  const {
    dateFrom,
    dateTo,
    pageOffset,
    pageSize,
    order,
    orderBy,
    searchTerm,
    searchText,
  } = filterSelectors.getFilters(state, nodes.merchantIncentives);
  try {
    const response = yield call(
        [axios, 'get'],
        API_ENDPOINTS.INCENTIVES.MERCHANT_LIST({ 
          dateFrom: `${format(dateFrom, "yyyy-MM-dd")}`,
          dateTo: `${format(dateTo, "yyyy-MM-dd")}`,
          orderBy,
          order,
          pageOffset,
          pageSize,
          searchTerm,
          searchText
        })
      )
    if (response.status == 200) {
      yield put(actions.fetchDataFulfilled(response.data.result));
    }
  } catch (err) {
    const errMsg = (err && err.message) || "Something went wrong";
    yield put(actions.fetchDataFailed(errMsg));
  }
}


/********** SAGAS **********/
export function* saga() {
  yield takeLatest(actionTypes.fetchData, fetchDataWorker);
  yield takeLatest(filterActionTypes.updateMerchantIncentiveFilter, fetchDataWorker);
}